import { useNavigate } from 'react-router-dom';
import { UserRole } from 'src/common/commonTypes';
import { Button, Form, Input, App } from 'antd';
import logo from 'src/assets/logo_mintrans_dark.svg';
import { AuthDataResponse } from 'src/api/contracts';
import authApiService from 'src/api/services/authApiService';
import authService from 'src/services/authService';
import { useAppDispatch } from 'src/store/store';
import { userLoggedIn } from 'src/userInfo/slice';
import { useEffect, useState } from 'react';
import usersApiService from 'src/api/services/usersApiService';

function LoginPage() {
    const { notification } = App.useApp();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        navigate('/');
    }, [navigate]);

    const onFinish = async (values: { login: string; password: string }) => {
        setIsLoading(true);
        let resp: AuthDataResponse;
        try {
            resp = await authApiService.login(values);
            authService.saveData({
                expiresIn: resp.expiresIn,
                token: resp.token
            });
            const user = await usersApiService.getCurrentUserInfo();
            dispatch(
                userLoggedIn({
                    userId: user.id,
                    userName: user.login,
                    userRole: UserRole[user.userRole as keyof typeof UserRole],
                    airlineCode: user.airlineIataCode,
                    airlineName: user.airlineName,
                    authorizationNumber: user.authorizationNumber,
                    hasRightToSign: user.hasRightToSign,
                    department: user.department,
                    isGeneralManager: user.isGeneralManager
                })
            );
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            if (error instanceof Error) {
                notification.error({ message: error.message });
            }
            return;
        }
    };

    return (
        <div className="login-page">
            <div className="login-page__content">
                <div className="login-page__body">
                    <div className="login-page__logo-wrapper">
                        <img className="login-page__logo" src={logo} alt="Минтранс" />
                    </div>
                    <div>
                        <div className="login-page__title">ПОРТАЛ СУБСИДИРОВАННЫХ ПЕРЕВОЗОК</div>
                        <Form className="login-page__form" layout="vertical" onFinish={onFinish}>
                            <Form.Item name="login" rules={[{ required: true, message: 'введите логин' }]}>
                                <Input placeholder="введите логин" />
                            </Form.Item>
                            <Form.Item name="password" rules={[{ required: true, message: 'введите пароль' }]}>
                                <Input.Password placeholder="введите пароль" />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={isLoading}>
                                    Войти в личный кабинет
                                </Button>
                            </Form.Item>
                        </Form>
                        <a
                            className="login-page__registration-help-link"
                            href="user-registration-guide.pdf"
                            download
                            target="_blank"
                            rel="noreferrer"
                        >
                            Порядок регистрации пользователей
                        </a>
                    </div>
                </div>
                <div className="login-page__footer">
                    <div className="login-page__footer-item">
                        <span>Служба поддержки</span>
                    </div>
                    <div className="login-page__footer-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                            <path d="M13.6186 10.7574c-.9279 0-1.8186-.1498-2.6499-.427-.2598-.0824-.5493-.0225-.7572.1798l-1.63294 1.6482c-2.10062-1.0788-3.82268-2.80942-4.89155-4.93705L5.32 5.56569c.20783-.19479.26722-.48696.18557-.74917-.27464-.83907-.4231-1.73807-.4231-2.67453 0-.41204-.33402-.74917-.74226-.74917H1.74227c-.40825 0-.74227.33713-.74227.74917C1 9.17667 6.64866 14.8778 13.6186 14.8778c.4082 0 .7422-.3371.7422-.7491v-2.6221c0-.4121-.334-.7492-.7422-.7492Zm-.7423-2.62207h1.4845c0-3.72336-2.9913-6.74251-6.68039-6.74251v1.49834c2.87259 0 5.19589 2.34489 5.19589 5.24417Zm-2.96908 0h1.48458c0-2.0677-1.66273-3.74584-3.71139-3.74584v1.49834c1.23217 0 2.22681 1.00388 2.22681 2.2475Z" />
                        </svg>
                        <span>8 (495) 380-21-53</span>
                    </div>
                    <a className="login-page__footer-item" href="mailto:support@asutk.ru">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                            <path d="M13.6 3.14087H2.4c-.77 0-1.393.61806-1.393 1.37347L1 12.7552c0 .7554.63 1.3735 1.4 1.3735h11.2c.77 0 1.4-.6181 1.4-1.3735V4.51434c0-.75541-.63-1.37347-1.4-1.37347Zm0 2.74695L8 9.3215 2.4 5.88782V4.51434L8 7.94803l5.6-3.43369v1.37348Z" />
                        </svg>
                        <span>support@asutk.ru</span>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
